import { AuthContext } from '@repo-level/core-front';
import { ProgressBarPalette } from 'components/progressBars/helpers';
import { SmallProgressBar } from 'components/progressBars/SmallProgressBar';
import { BonanzaContext } from 'contexts/bonanza';
import { BonanzaStatus } from 'helpers/bonanza';
import { PERCENT_BREACKPOINTS_BONANZA } from 'modules/bonanza/components/BoxSection/helpers';
import { useBonanzaLogic } from 'modules/bonanza/hooks/useBonanzaLogic';
import type { FC } from 'react';
import { useContext, useMemo } from 'react';
import { useNavigation } from 'react-navi';
import { Addons } from './Addons';
import { ScBonanzaPromoSection } from './styled';

export interface BonanzaPromoSectionProps {
  isMobile?: boolean;
  onLinkClick?: () => void;
}

export const BonanzaPromoSection: FC<BonanzaPromoSectionProps> = ({
  isMobile = false,
  onLinkClick,
}) => {
  const { bonanzaData, bonanzaLevelItem, userBonanzaGroup } =
    useContext(BonanzaContext);
  const { isAuthenticated } = useContext(AuthContext);
  const { navigate } = useNavigation();
  const { isBonusIssued, isBonusLocked } = useBonanzaLogic();

  const isHighlighted = useMemo(
    () =>
      [
        BonanzaStatus.LEVEL3,
        BonanzaStatus.LEVEL4,
        BonanzaStatus.BONUS_ISSUED,
      ].includes(userBonanzaGroup),
    [userBonanzaGroup]
  );

  const { bg } = bonanzaData?.menu ?? {};
  const isPromoAvailable = isAuthenticated && !isBonusLocked && !isBonusIssued;

  if (!(bonanzaData && bonanzaLevelItem)) return null;

  return (
    <ScBonanzaPromoSection
      $bgMenu={bg?.url || ''}
      $isBonusIssued={isBonusIssued}
      $isHighlighted={isHighlighted}
      $isMobile={isMobile}
      onClick={() => {
        onLinkClick?.();
        navigate('/bonanza');
      }}
    >
      <Addons isMobile={isMobile} />

      {isPromoAvailable && !isMobile && (
        <>
          <SmallProgressBar
            config={{
              dotsCount: PERCENT_BREACKPOINTS_BONANZA.length,
              color: ProgressBarPalette.PURPLE,
            }}
            userProgress={bonanzaLevelItem.progressPercent}
          />
          <p className="under-progress-text">
            {bonanzaLevelItem.progressPercent}%
          </p>
        </>
      )}
    </ScBonanzaPromoSection>
  );
};
